import { Box, Image } from '@chakra-ui/react';

import emptyState from 'Asset/image/siglive-empty-state-2.svg';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const EmptyStateForm = ({ t }) => {
  return (
    <Box className={styles['empty-state-form__container']}>
      <Image src={emptyState} width="160px" />
      <Box className={styles['text__container']}>
        <TextSemiBold>{t('form.emptyStateTitle')}</TextSemiBold>
        <TextRegular>{t('form.emptyStateDesc')}</TextRegular>
      </Box>
    </Box>
  );
};

export default EmptyStateForm;
